import usePDPContext from './usePDPContext';

const DEFAULT_VALUE = {};

const usePDPBasicDetails = () => usePDPContext()?.basicDetails ?? DEFAULT_VALUE;

export default usePDPBasicDetails;
